let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gAB0r")).then(() => parcelRequire('iavkQ'));